import { useDocumentTitle } from 'usehooks-ts';
import { Redemption } from 'referral/components';
import { useParams } from 'react-router';
import { useGetCouponQuery } from 'drycut-graphql';
import { Loader } from 'ui-components';

export function ReferralRedemption(): React.ReactElement {
  useDocumentTitle('DryCut Referral');

  const { code } = useParams() as { code: string };
  const { data, loading } = useGetCouponQuery({ variables: { code } });

  if (loading) {
    return <Loader />;
  }

  return <Redemption coupon={data?.coupon} />;
}
